var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPauseCtaFilled = function SvgPauseCtaFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.859 23.5c-.935 0-1.7-.84-1.7-1.866V2.365C3.158 1.34 3.923.5 4.858.5H7.59c.936 0 1.7.84 1.7 1.865v19.27c0 1.025-.764 1.865-1.7 1.865H4.86Zm9.849-21.134c0-1.026.766-1.866 1.7-1.866h2.733c.935 0 1.7.84 1.7 1.866v19.269c0 1.025-.765 1.865-1.7 1.865h-2.733c-.934 0-1.7-.84-1.7-1.865V2.365Z",
    fill: "currentColor"
  })));
};
export default SvgPauseCtaFilled;